export const HIS_CONNECTION_PERMISSION = {
  VIEW: 'SYS_HIS_CONNECTION_VIEW',
  ADD: 'SYS_HIS_CONNECTION_ADD',
  EDIT: 'SYS_HIS_CONNECTION_EDIT',
  DEL: 'SYS_HIS_CONNECTION_DEL',
};

export const HIS_SYNC_PERMISSION = {
  VIEW: 'SYS_HIS_SYNC_VIEW',
  RUN: 'SYS_HIS_SYNC_RUN',
  MAP: 'SYS_HIS_SYNC_MAP',
};

export const HIS_SYNC_MATCH_STATUS_OPTIONS = [
  { value: 'UNMAPPED', label: 'Chưa map' },
  { value: 'CONFLICT', label: 'Trùng/Không chắc' },
  { value: 'AUTO_MATCHED', label: 'Tự động map' },
  { value: 'MANUAL_MATCHED', label: 'Map thủ công' },
  { value: 'IGNORED', label: 'Bỏ qua' },
];

export const HIS_CONNECTION_ACTIVE_OPTIONS = [
  { value: 1, label: 'Kích hoạt' },
  { value: 0, label: 'Ẩn' },
];

export const HIS_CONNECTION_BOOLEAN_OPTIONS = [
  { value: 1, label: 'Có' },
  { value: 0, label: 'Không' },
];

export const HIS_CONNECTION_DEFAULT_VALUES = {
  business_id: null,
  connection_name: '',
  his_code: '',
  server_host: '',
  server_port: 1433,
  database_name: '',
  db_username: '',
  db_password: '',
  is_change_password: 0,
  encrypt: 1,
  trust_server_certificate: 1,
  request_timeout: 60000,
  connection_timeout: 60000,
  description: '',
  is_active: 1,
};
